<template>
  <ColumnsEffect>
    <div
      v-for="computer of items"
      :key="computer.uid"
      class="column is-3 is-marginless is-paddingless"
      @contextmenu.prevent="$emit('menu', { e: $event, computer: computer })"
    >
      <router-link
        v-if="!computer.edit"
        :to="
          `/domains/${$route.params.domainUID}/computers/${computer.uid}/packages`
        "
      >
        <span
          :data-tooltip="
            $store.state.settings.server.licenseEnabled
              ? computer.license && !computer.license.active
                ? 'License is deactivated'
                : !computer.license
                ? 'No license'
                : undefined
              : false
          "
        >
          <span class="icon">
            <i
              class="mdi mdi-laptop"
              :class="{
                'has-text-success': computer.online,
                'has-text-grey': !computer.online,
              }"
            ></i>
          </span>
          <span
            :class="{
              'has-text-danger':
                $store.state.settings.server.licenseEnabled &&
                !computer.license,
              'has-text-warning':
                $store.state.settings.server.licenseEnabled &&
                computer.license &&
                !computer.license.active,
            }"
            >{{ name(computer) }}</span
          >
          <span
            v-if="computer.inventorying"
            class="margin-left-5"
            data-tooltip="Inventorying"
          >
            <span class="dot small has-background-info"> </span>
          </span>
        </span>
      </router-link>
      <EditSingleField
        v-if="computer.edit"
        :text="name(computer)"
        validation="required"
        type="text"
        name="name"
        @save="$emit('save', { computer: computer, text: $event })"
        @cancel="$emit('cancel', computer)"
        :isLoading="computer.saving"
      ></EditSingleField>
    </div>
  </ColumnsEffect>
</template>

<script>
import computerHelper from "@/utils/computer";
import { parseAndRound } from "@/utils/string";
import { fromNow } from "@/utils/date";
export default {
  props: { items: Array },
  components: {
    ColumnsEffect: () => import("@/components/singles/ColumnsEffect.vue"),

    EditSingleField: () =>
      import("@/components/singles/EditSingleField/component.vue"),
  },
  computed: {
    parseAndRound() {
      return (str) => {
        return parseAndRound(str);
      };
    },
    name() {
      return (computer) => {
        return computerHelper.getName(computer);
      };
    },
    fromNow() {
      return (date) => {
        return fromNow(date);
      };
    },
  },
};
</script>
